import type { ComponentProps } from 'react'

import type { Button } from '~/components/ui/button'

import { PaymentMethodsList } from '../organisms/payment-methods-list'
import { FormAddNewCard } from './form-add-new-card'

interface PaymentMethodsManagerProps {
	onPaymentMethodAdded?: VoidFunction
	onDefaultPaymentMethodUpdated?: VoidFunction
	addFormButtonVariant?: ComponentProps<typeof Button>['variant']
}

export const PaymentMethodsManager = ({
	addFormButtonVariant,
	onPaymentMethodAdded,
	onDefaultPaymentMethodUpdated,
}: PaymentMethodsManagerProps) => {
	return (
		<div className='flex flex-col gap-8 md:flex-row'>
			<PaymentMethodsList onSetDefault={onDefaultPaymentMethodUpdated} />

			<div className='md:w-[500px]'>
				<FormAddNewCard
					addFormButtonVariant={addFormButtonVariant}
					onSubmitSuccess={onPaymentMethodAdded}
				/>
			</div>
		</div>
	)
}
